export {
  SHIPPING_METHOD_SLUGS,
  DEFAULT_SHIPPING_METHOD_SLUG,
} from "@shared-types/shipping-methods";
export type {
  ShippingMethodSlug,
  ShippingMethodOption,
} from "@shared-types/shipping-methods";

import type { ShippingMethodOption } from "@shared-types/shipping-methods";

export const SHIPPING_METHODS: readonly ShippingMethodOption[] = [
  { slug: "ground", label: "Ground" },
  { slug: "2day", label: "2-Day" },
  { slug: "priority-overnight", label: "Priority Overnight" },
];

export const getShippingMethodLabel = (
  slug: ShippingMethodOption["slug"] | undefined | null,
  methods: readonly ShippingMethodOption[] = SHIPPING_METHODS
): string | undefined => methods.find((m) => m.slug === slug)?.label;

export const toShippingMethodSelectOptions = (
  methods: readonly ShippingMethodOption[] = SHIPPING_METHODS
) => methods.map((m) => ({ label: m.label, value: m.slug }));
